import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { AiOutlineLoading } from 'react-icons/ai';
import Button from '../components/Button/Button';
import { getActiveCourse } from '../services/settings';


const SearchEligibility = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState(null);
    const [courseData, setCourseData] = useState(null);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const fetchActiveCourse = async () => {
        setIsLoading(true);
        try {
            const response = await getActiveCourse();
            const data = response.data.data;

            if (response.status === 200) {
                if (data.length === 0) {
                    setCourseData(null);
                } else {
                    setCourseData(data[0]);
                }
            } else {
                toast.error(t('general.ActionFailed'));
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchActiveCourse();
    }, []);

    // const handleSubmit = async () => {
    //     setIsLoading(true);
    //     try {
    //         const response = await userLogin(formData);
    //         const data = response.data.data;
    //         if (data === 404) {
    //             toast.error(t("login.invalidUsername"));
    //         } else if (data === 401) {
    //             toast.error(t("login.invalidCredentials"));
    //         } else {
    //             toast.success(t("login.loginSuccess"));
    //             navigate(`${base_url}/`)
    //         }
    //     } catch (error) {
    //         errorToast(error, t("general.ActionFailed"), t);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    return (
        <>
            {
                isLoading && !courseData ?
                    <div className='m-5 d-flex justify-content-center'>
                        <AiOutlineLoading className='spin' />
                    </div>
                    :
                    !courseData ?
                        <>
                            <div className='form-wrapper d-flex flex-column'>
                                <h3 className='mt-5 d-flex justify-content-center'>{t("login.notOpen")}</h3>
                            </div>
                        </>

                        :
                        <>
                            <div className='form-wrapper d-flex flex-column'>
                                <h3 className='mt-5 d-flex justify-content-center'>{t("navbar.eligibilityCheck")}</h3>
                                <p className='d-flex justify-content-center text-center'>{localStorage.getItem("i18nextLng") === "en" ? courseData.course_ename : courseData.course_cname}</p>
                                <div className='form-wrapper d-flex flex-column'>
                                    <h3 className='mt-5 d-flex justify-content-center'>{t("login.notOpen")}</h3>
                                </div>
                                {/* <form>
                                    <div className="input-group d-flex justify-content-center">
                                        <input
                                            type="text"
                                            value={formData?.student_no || ""}
                                            className="form-control"
                                            id="student_no"
                                            placeholder={t("login.studentNo")}
                                            onChange={handleInputChange}
                                            name="student_no"
                                            required
                                        />
                                    </div>
                                    <div className='submit-button mt-4 d-flex justify-content-center'>
                                        <Button buttonStyle='btn--primary' disabled={isLoading} onClick={handleSubmit} type='button'>
                                            {isLoading ? <AiOutlineLoading className="spin" /> : t('login.save')}
                                        </Button>
                                    </div>
                                </form> */}
                            </div>
                        </>
            }
        </>
    )
}
export default SearchEligibility